interface NameSourceMyUser {
	email?: null | string;
	fullName?: null | string;
}

interface NameSourceCurrentUser {
	displayName?: null | string;
	email?: null | string;
}

const isRealName = (candidate: null | string | undefined, email: string): boolean => {
	const trimmed = candidate?.trim();
	if (!trimmed) return false;
	return trimmed.toLowerCase() !== email.trim().toLowerCase();
};

const resolveUserDisplayName = (
	myUser: NameSourceMyUser | undefined,
	currentUser: NameSourceCurrentUser | null | undefined
): null | string => {
	const email = myUser?.email ?? currentUser?.email ?? "";
	const candidates = [myUser?.fullName, currentUser?.displayName];
	for (const candidate of candidates) {
		if (isRealName(candidate, email)) return candidate!.trim();
	}
	return null;
};

export default resolveUserDisplayName;
